import * as XLSX from "xlsx";
import jsPDF from "jspdf";

export const exportToXLSX = (data, filename) => {
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Email-Logger");
  XLSX.writeFile(wb, filename);
};

// Utility function to capitalize the first letter of each word
const capitalizeFirstLetter = (string) => {
  return string
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// Utility function to format the date
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${month}/${day}/${year}`;
};

export const exportToPDF = (formData, filename) => {
  const doc = new jsPDF();
  let yPosition = 10;

  
  // Add title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text(
    10,
    yPosition,
    `Enrollment Email logger Form of ${formData.studentFirstName} ${formData.studentLastName}`
  );
  yPosition += 15;

  // Define section headings based on age
  let sections;
  if (formData.age >= 18) {
    sections = {
      "Learning Center Information": [
        "learningCenterName",
        "learningCenterCharter",
        "learningCenterAddress",
         "_uuid",
      ],
      "Student Information": [
        "studentFirstName",
        "studentLastName",
        "birthDate",
        "age",
      ],
      "Contact Information": ["primaryEmail", "phone"],
      "Physical Address": [
        "street1",
        "street2",
        "state",
        "region",
        "city",
        "country",
        "zipCode",
        "sameAddress",
      ],
      "Mailing Address": [
        "mailingStreet1",
        "mailingStreet2",
        "mailingCity",
        "mailingState",
        "mailingRegion",
        "mailingCountry",
        "mailingZipCode",
      ],
    };

    // Remove "Student Mailing Address" section if sameAddress is true
    if (formData.sameAddress) {
      delete sections["Mailing Address"];
    }
  } else {
    sections = {
      "Learning Center Information": [
        "learningCenterName",
        "learningCenterCharter",
        "learningCenterAddress",
         "_uuid",
        
      ],
      "Student Information": [
        "studentFirstName",
        "studentLastName",
        "birthDate",
        "age",
      ],
      "Parent Information": [
        "parentRelationship",
        "parentFirstName",
        "parentLastName",
      ],
      "Contact Information": ["primaryEmail", "phone"],
      "Physical Address": [
        "street1",
        "street2",
        "state",
        "region",
        "city",
        "country",
        "zipCode",
        "sameAddress",
      ],
      "Mailing Address": [
        "mailingStreet1",
        "mailingStreet2",
        "mailingCity",
        "mailingState",
        "mailingRegion",
        "mailingCountry",
        "mailingZipCode",
      ],
    };

    // Remove "Parent Mailing Address" section if sameAddress is true
    if (formData.sameAddress) {
      delete sections["Mailing Address"];
    }
  }

  // Add content to the PDF
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");

  Object.entries(sections).forEach(([sectionTitle, keys]) => {
    const capitalizedSectionTitle = capitalizeFirstLetter(sectionTitle);

    doc.setFontSize(12); // Set font size for section headings
    doc.setFont("helvetica", "bold");
    doc.text(15, yPosition, capitalizedSectionTitle);
    yPosition += 10;

    doc.setFontSize(12); // Set font size for field values
    doc.setFont("helvetica", "normal");

    keys.forEach((key) => {
      if (formData[key]) {
        let value = formData[key];
        let capitalizedField = capitalizeFirstLetter(
          key.replace(/([A-Z])/g, " $1").trim()
        );
        // Replace specific field names with more readable text
        capitalizedField = capitalizedField.replace(
          /\bSame Address\b/g,
          "Mailing Address Same"
        );

        capitalizedField = capitalizedField.replace(
          /\bStudent First Name\b/g,
          "First Name"
        );

        capitalizedField = capitalizedField.replace(
          /\bStudent Last Name\b/g,
          "Last Name"
        );

        capitalizedField = capitalizedField.replace(
          /\bPhone\b/g,
          "Phone Number"
        );
        capitalizedField = capitalizedField.replace(
          /\bParent Relationship\b/g,
          "Parent Relationship To Student"
        );

       capitalizedField = capitalizedField.replace(
  /\b_uuid\b/g,
  "Registration ID"
        );

        if (key === "birthDate") {
          const formattedDate = formatDate(value);
          value = `${formattedDate}`;
        }

        doc.text(15, yPosition, `${capitalizedField}: ${value}`);
        yPosition += 10;
        if (yPosition > 280) {
          doc.addPage();
          yPosition = 15;
        }
      }
    });

    // Add extra spacing after each section
    yPosition += 8;
    if (yPosition > 280) {
      doc.addPage();
      yPosition = 15;
    }
  });

  // Save the PDF
  doc.save(filename);
};
